import { render } from "./CadastrarRedeSocial.vue?vue&type=template&id=2c64e7de&scoped=true"
import script from "./CadastrarRedeSocial.vue?vue&type=script&lang=js"
export * from "./CadastrarRedeSocial.vue?vue&type=script&lang=js"

import "./CadastrarRedeSocial.vue?vue&type=style&index=0&id=2c64e7de&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c64e7de"]])

export default __exports__